import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const creditCategoryService = {
    getAll,
    getAllCreditCategories,
    getCreditCategory,
    addCreditCategory,
    updateCreditCategory,
    deleteCreditCategory,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction, selectedGrades, selectedSubjects, selectedLanguages, selectedExamCategories) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-categories/getAllCreditCategories/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}&selectedGrades=${selectedGrades}&selectedSubjects=${selectedSubjects}&selectedLanguages=${selectedLanguages}&selectedExamCategories=${selectedExamCategories}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllCreditCategories() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-categories/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addCreditCategory(newCreditCategory) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newCreditCategory),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-categories/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getCreditCategory(requestBody) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(requestBody),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-categories/getCreditCategory/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateCreditCategory(creditCategoryItem, creditCategoryId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(creditCategoryItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-categories/update/${creditCategoryId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteCreditCategory(creditCategoryId) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-categories/delete/${creditCategoryId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
